import { Checkbox, Col, Form, FormInstance, Row } from "antd";
import { useFetchInfo } from "../../hooks/useFetchInfo";
import { Loader } from "../../../../../../../components/Loader";
import { CustomerInfo } from "./CustomerInfo";
import { IncidentNature } from "./IncidentNature";
import { OptionalValues } from "./OptionalValues";
import { Footer } from "./Footer";
import { AdditionalInfo } from "./AdditionalInfo";
import { useSave } from "../../hooks/useSave";

type ItemDetailsProps = {
  type: 1 | 2;
  id: string | undefined | null;
  entryNumber: number | undefined;
  close: () => void;
  reloadData: () => void;
};

export const ItemDetails = ({
  type,
  id,
  entryNumber,
  close,
  reloadData,
}: ItemDetailsProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const { isLoading, customerId, initialValues, setCustomerId } = useFetchInfo(
    type,
    id,
    entryNumber,
    form,
  );

  const { isSaving, save } = useSave(form, close, reloadData);

  return (
    <>
      <Row className="py-8 px-6 d-block sidebar-body user-content incident-report">
        {isLoading ? (
          <Loader fontSize="64px" />
        ) : (
          <Form
            form={form}
            autoComplete="off"
            layout="vertical"
            className="w-100"
            requiredMark={false}
            disabled={!!id || isSaving}
            initialValues={initialValues}
          >
            <CustomerInfo
              id={id}
              form={form}
              type={type}
              isSaving={isSaving}
              customerId={customerId}
              setCustomerId={setCustomerId}
            />

            <IncidentNature />

            <OptionalValues />

            <Row className="w-100">
              <Col span={12} className="pr-7">
                <AdditionalInfo
                  title="Reporter"
                  subTitle="Reporting employee information"
                  fullNameFormName="reporterName"
                  titleFormName="reporterTitle"
                  disabled
                />
              </Col>
              <Col span={12} className="pl-7">
                <AdditionalInfo
                  title="Witness (If applicable)"
                  subTitle="Employee witness information"
                  fullNameFormName="witnessFullName"
                  titleFormName="witnessTitle"
                  disabled={!!id || isSaving}
                />
              </Col>
            </Row>
            {!id && (
              <Row className="mt-6 w-100">
                <Form.Item
                  name="confirmation"
                  className="mb-0 w-100"
                  valuePropName="checked"
                >
                  <Checkbox>
                    I confirm that all information in this report is accurate
                    and complete.
                  </Checkbox>
                </Form.Item>
              </Row>
            )}
          </Form>
        )}
      </Row>
      <Footer
        form={form}
        id={id}
        isSaving={isSaving}
        save={save}
        close={close}
      />
    </>
  );
};
